import React from 'react';

import {TextMain, ViewLine} from './layout/PDFLayout';
import {BaselinePDFItemType} from './BaselinePDFTypes';

type BaselinePDFItemProps = {
	item: BaselinePDFItemType;
};
const BaselinePDFItem = ({item}: BaselinePDFItemProps): JSX.Element => {
	return (
		<ViewLine>
			<TextMain style={{width: '40%'}}>{item.name}</TextMain>
			<TextMain style={{textAlign: 'right', width: '20%'}}>{item.hours}</TextMain>
			<TextMain style={{textAlign: 'right', width: '20%'}}>{item.hourlyRate}</TextMain>
			<TextMain bold style={{textAlign: 'right', width: '20%'}}>
				{item.totalPrice}
			</TextMain>
		</ViewLine>
	);
};

export default BaselinePDFItem;
